import { Link, Outlet, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useEnergyAnalysis } from '../../hooks/useEnergyAnalysis';
import { useBuildingData } from '../../hooks/useBuildingDetails/buildingDetailsHooks';
import RegistrationFormProvider from '../registration/useRegistrationForm/provider';
import { Energimerkeversjon } from '../../types/energimerke';
import { useGetUserInput } from '../registration/hooks/useGetUserInput';

import { Stepper } from './components/stepper';
import {
  BreadcrumbsWrapper,
  MainContentWrapper,
  SidebarPageLayout,
  SidebarWrapper
} from './components/styledComponents';
import { SidebarPageLoader } from './components/pageLoader';
import { ErrorState } from './components/errorState';

export const RegistrationLayout = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const { energyAnalysis, energyAnalysisLoading } = useEnergyAnalysis(params.registrationId || '');
  const { buildingLoading, building } = useBuildingData(energyAnalysis?.registrering.energiObjektId);
  const { isLoading: userInputLoading, userInputError } = useGetUserInput(params.registrationId, () => {});

  if (energyAnalysisLoading || userInputLoading || buildingLoading) {
    return <SidebarPageLoader />;
  }

  if (!energyAnalysis || userInputError) {
    return <ErrorState />;
  }

  // User should not be able to access the registration if the energiplan is published - redirect to energiattest page
  if (energyAnalysis.energiplan?.publisertDato) {
    navigate('energiattest');
  }

  // The registration flow has two entry points, building and energiplan. The return path should be different depending on the entry point.
  const isEnergiplan = !!energyAnalysis?.registrering.soknadId;
  const returnPath = isEnergiplan ? `/energiplan/${building?.energiObjektId}` : `/bygg/${building?.energiObjektId}`;

  return (
    <RegistrationFormProvider registrationId={params.registrationId} energimerkeversjon={Energimerkeversjon.V2025}>
      <SidebarPageLayout>
        <BreadcrumbsWrapper>
          <Breadcrumbs>
            <Breadcrumbs.Link asChild aria-label={t('registrering.back')}>
              <Link to={returnPath}>{t('registrering.back')}</Link>
            </Breadcrumbs.Link>
          </Breadcrumbs>
        </BreadcrumbsWrapper>
        <SidebarWrapper>
          <Stepper />
        </SidebarWrapper>
        <MainContentWrapper>
          <Outlet />
        </MainContentWrapper>
      </SidebarPageLayout>
    </RegistrationFormProvider>
  );
};
